export const SET_NONPROFIT_LIST = 'SET_NONPROFIT_LIST';
export const UPDATE_NONPROFIT_LIST = 'UPDATE_NONPROFIT_LIST';
export const SET_TOTAL_NONPROFITS_BY_QUERY = 'SET_TOTAL_NONPROFITS_BY_QUERY';
export const SET_SELECTED_CAUSES = 'SET_SELECTED_CAUSES';
export const SET_TEMPLATE = 'SET_TEMPLATE';
export const SET_QUERY_NUMBER = 'SET_QUERY_NUMBER';
export const SET_REMOTE_FRIENDLY = 'SET_REMOTE_FRIENDLY';
export const SET_MEMBER_METROPOLITAN_AREAS = 'SET_MEMBER_METROPOLITAN_AREAS';
export const SET_OPEN_OPPORTUNITIES = 'SET_OPEN_OPPORTUNITIES';
export const SET_KEYWORDS = 'SET_KEYWORDS';
export const SET_EVENT_TYPES = 'SET_EVENT_TYPES';
export const SET_FUNNEL_TYPES = 'SET_FUNNEL_TYPES';




// WEBPACK FOOTER //
// ./static-content/private/javascripts/store/modules/searchAndDiscovery/mutation-types.ts